import React, { useState, useEffect } from "react";
import { RouteComponentProps } from "react-router";
import { toastr } from "react-redux-toastr";
import ReactPlayer from "react-player-linkorn-ruvideo";
import { IPriceClass, IProductContent, IProduct } from "types/product";
import { Actions as cartActions, IAddCartProduct } from "reducers/cart";
import { connect } from "react-redux";
import { getRefBonus } from "reducers/user";
import { IRootState } from "reducers";
import cn from "classnames";
import { Link } from "react-router-dom";

import Counter from "components/Counter";
import SelectClass from "components/SelectClass";
import Slider from "components/Slider";
import CardProduct from "components/CardProduct";
import { getPrice, getBonus } from '../../utils/helpers';

import * as API from "api/product";

interface ICard {
  addOrUpdateToCart: (payload: IAddCartProduct) => void;
  refBonus: number;
}

const isVideo = (content: IProductContent) => content.type === "video";
const isImage = (content: IProductContent) => content.type === "image";

const CardPage: React.FC<RouteComponentProps<{ id: string }> & ICard> = ({
  match,
  addOrUpdateToCart,
  refBonus
}) => {
  const {
    params: { id }
  } = match;
  const currentCardId = parseInt(id, 10);

  const [data, setData] = useState<IProduct | undefined>(undefined);

  const [popularProducts, setPopularProducts] = useState<any[]>([]);

  const [isLoading, setLoading] = useState(false);

  const fetchProductData = (page: number) => {
    setLoading(true);
    API.getProductById(page)
      .then((response: any) => {
        if (response.success) {
          if (response.data) {
            setData(response.data);
            if (response.data.product_price_classes.length) {
              setSelectedClass(response.data.product_price_classes[0]);
            }
          } else {
            setData(undefined);
          }
        } else {
          toastr.error("Ошибка загрузки продукта", response.error);
        }
        setLoading(false);
      })
      .catch(e => setLoading(false));
  };

  useEffect(() => {
    fetchProductData(currentCardId);
  }, [currentCardId]);

  useEffect(() => {
    if (data) {
      API.getProductsByCategory(data.category_id, data.id).then(
        (response: any) => {
          if (response.success) {
            setPopularProducts(response.data);
          } else {
            toastr.error(
              "Ошибка загрузки популярных продуктов",
              response.error
            );
          }
        }
      );
    }
  }, [data]);

  const [selectedClass, setSelectedClass] = useState<undefined | IPriceClass>(
    undefined
  );

  const [count, setCount] = useState(1);

  const handleChangeClass = (value: IPriceClass) => {
    setSelectedClass(value);
  };

  const handleChangeCount = (value: number) => {
    setCount(value);
  };

  // Цена
  const price = selectedClass && data ? getPrice(selectedClass.price, data.top_discount_pct) : 0;
  // Бонус агенту
  const bonus = data ? getBonus(
    price,
    data.agent_fee_pct,
    data.agent_fee_rub,
    data.top_agent_fee_pct,
    refBonus
  ) : 0;

  return (
    <React.Fragment>
      <div className="container bug_1200 slider-modal">
        {data && (
          <React.Fragment>
            <div className="row">
              <div className="col-12">
                <Link to="/home/catalog/page/0" className="btn card-catalog-btn">
                  В каталог
                </Link>
              </div>
              <div
                className={cn("col-12 col-lg-5 product-slider", {
                  "img-style": data.product_content.filter(isImage).length < 4
                })}
              >
                <Slider
                  options={data.product_content
                    .filter(isImage)
                    .map(i => i.content)}
                />
              </div>
              <div className="col-12 col-lg-7">
                <div className="description">
                  <h3>{data.name}</h3>
                  <p className="pre-wrap">{data.description}</p>
                  { Array.isArray(data.product_features) && data.product_features.length
                    ? <div className="row no-gutters po">
                      <ul className="hmm features-list">
                        {data.product_features.map((item, index: number) => (
                          <li key={`item-${index}`}>
                            <div><span className="pr-1">{item.feature}</span></div>
                            <strong>{item.value}</strong>
                          </li>
                        ))}
                      </ul>
                    </div>
                    : null
                  }
                  <div className="row no-gutters">
                    <div className="col-12 col-md-9 d-flex align-items-end   price-block">
                      <div className="row no-gutters">
                        <div className="col-12 col-md-6 d-flex align-items-center mobile-style">
                          {selectedClass &&
                            selectedClass.car_class_id !== 0 && (
                              <SelectClass
                                value={selectedClass}
                                options={data.product_price_classes}
                                onChange={handleChangeClass}
                                text={"Класс:"}
                              />
                            )}
                          <Counter
                            minCount={1}
                            value={count}
                            onChange={handleChangeCount}
                          />
                        </div>
                        <div className="col-12 col-md-6 mobile-style">
                          <div className="row no-gutters">
                            <span className="card__comment-span d-none d-md-block">
                              Рыночная цена:
                            </span>
                            <span className="card__comment-span bold ml-0 d-none d-md-block">
                              {selectedClass
                                ? Math.round(selectedClass.market_price * 100) /
                                  100
                                : "0"}{" "}
                              ₽
                            </span>
                          </div>
                          <button
                            className="cards__price-btn btn px-0 py-0 text-left"
                            onClick={() =>
                              addOrUpdateToCart({
                                product_id: data.id,
                                car_classes_id: selectedClass!.car_class_id,
                                quantity: count
                              })
                            }
                          >
                            {price} ₽
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-3">
                      <div className="grey__text d-md-none">
                        <strong>
                          {selectedClass
                            ? Math.round(selectedClass.market_price * 100) / 100
                            : "0"}
                        </strong>
                        <span>Рыночная цена</span>
                      </div>
                      <div className="green__text">
                        <strong>
                          {bonus} ₽
                        </strong>
                        <span>Ваш бонус</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {data.product_content.some(isVideo) && (
              <div className="row bug_1200_row">
                <div className="col-12">
                  <h2 className="video__title">Видео</h2>
                </div>
                <div className="videos-container">
                  {data.product_content
                    .filter(isVideo)
                    .map((item, index: number) => (
                      <div className="markg card-video" key={`item-${index}`}>
                        <ReactPlayer
                          controls={true}
                          url={item.content}
                          playing={false}
                          width={"100%"}
                          height={"100%"}
                        />
                      </div>
                    ))}
                </div>
              </div>
            )}
            <div
              className={cn("row bug_1200_row popular-products-container", {
                "card-quant":
                  popularProducts.filter(i => i.id !== data.id).length < 4
              })}
            >
              <div className="col-12">
                <h2 className="goods__title">Популярные товары</h2>
              </div>
              <div
                className={cn(
                  "col-12 d-md-flex justify-content-between popular-products"
                )}
              >
                {popularProducts
                  .filter(i => i.id !== data.id)
                  .map((item, index: number) => (
                    <CardProduct {...item} key={`item-${index}`} />
                  ))}
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = ({ user }: IRootState) => ({
  refBonus: getRefBonus(user)
});

const actions = {
  addOrUpdateToCart: cartActions.addOrUpdateToCart
};

export default connect(
  mapStateToProps,
  actions
)(CardPage);
